var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from 'root/src/client/v2/common/components/ui/dialog';
import { Button } from 'root/src/client/v2/common/components/ui/button';
import { useIsAuthenticated } from 'root/src/client/v2/auth/hooks/useIsAuthenticated';
import { trpc } from 'root/src/client/v2/trpc/trpc';
import { getDateWithTimezone } from 'root/src/shared/util/getDateWithTimezone';
import { DateTimePicker } from 'root/src/client/v2/common/components/ui/datetime-picker';
import { FIELD_LABEL_CLASS, streamDateBounds } from 'root/src/client/v2/_pages/drop/redesign/streamDate';
import { useAsyncAction } from 'root/src/client/v2/common/hooks/useAsyncAction';
export const ReservationDialog = ({ drop }) => {
    const isAuthenticated = useIsAuthenticated();
    const utils = trpc.useUtils();
    const updateMutation = trpc.pointsApplication.update.useMutation();
    const { loading, success, error, run } = useAsyncAction();
    const [open, setOpen] = useState(false);
    const [streamDate, setStreamDate] = useState('');
    if (!isAuthenticated || !drop.canUserReclaimReservation) {
        return null;
    }
    const { min, max } = streamDateBounds(drop);
    const onSave = () => {
        if (!streamDate) {
            return;
        }
        void run(() => __awaiter(void 0, void 0, void 0, function* () {
            yield updateMutation.mutateAsync({ dropId: drop.id, streamDate: new Date(streamDate).toISOString() });
            yield utils.drops.getDrop.invalidate({ mnemonicId: drop.mnemonicId });
        }), {
            onSuccess: () => setOpen(false),
            toast: {
                loading: 'Updating points application...',
                success: 'Points application updated. You will be notified if your application is accepted.',
                error: caught => (caught instanceof Error ? caught.message : 'Could not update your reservation'),
            },
        });
    };
    return (<>
			<Button variant="outline" onClick={() => setOpen(true)} className="mt-3 w-full rounded-lg text-xs font-semibold">
				Reclaim points reservation
			</Button>

			<Dialog open={open} onOpenChange={setOpen}>
				<DialogContent className="redesign max-w-md gap-0 overflow-hidden border-white/[0.08] bg-card/95 p-0 backdrop-blur-xl">
					<DialogHeader className="border-b border-solid border-white/[0.06] px-5 py-4 text-left">
						<DialogTitle className="font-display text-base font-semibold">Update Points Application</DialogTitle>
						<DialogDescription className="text-xs text-muted-foreground">
							<span className="font-semibold text-foreground">{drop.campaignName}</span> launch date is now {getDateWithTimezone(drop.liveDate)}. Update your planned stream date to match.
						</DialogDescription>
					</DialogHeader>

					<div className="px-5 py-4">
						<label htmlFor="reserve-stream-date" className={FIELD_LABEL_CLASS}>Planning to stream at</label>
						<DateTimePicker id="reserve-stream-date" value={streamDate} onChange={setStreamDate} min={min} max={max}/>
					</div>

					<div className="border-t border-solid border-white/[0.06] px-5 py-4">
						<Button variant="brand" loading={loading} success={success} error={error} disabled={!streamDate} onClick={onSave} className="w-full rounded-lg text-sm font-semibold">
							Save
						</Button>
					</div>
				</DialogContent>
			</Dialog>
		</>);
};
